export default "__VITE_ASSET__DW7xh_v4__"